import Routes from "../../Routes/index";
import { onAppStart } from "../../modules/auth";
import {onInspectorAppStart} from "../../modules/Inspector/auth";
import {onAdminAppStart} from "../../modules/AdminConsole/auth";
import {getBasicInfo} from "../../modules/BindingPharmacy/basicInfo";
import { connect } from "react-redux";

const mapStateToProps = state => {
    const { auth, InspectorAuth, AdminAuth } = state;

    const  inspection_department = window.location.href.includes("inspection-department") ? true: false;
    const admin_console = window.location.href.includes("admin-console") ? true: false;

    let category = localStorage.getItem("user_category");
    
    let authObject;

    if(!admin_console && !inspection_department){
	authObject = auth;
	localStorage.setItem("user_category", "Distributor");
    }
    
    else if((inspection_department || category==="Inspection-Department") && !admin_console){
	authObject = InspectorAuth;
	localStorage.setItem("user_category", "Inspection-Department");
    }
    else if(admin_console || category==="Admin-Console"){
	authObject = AdminAuth;
	localStorage.setItem("user_category", "Admin-Console");
    }

    return {
	authenticated: authObject.authenticated ? authObject.authenticated : false,
	authenticatedUser: authObject.authenticated_user,
	authRedirection: authObject.authRedirection,
	unauthorizedError: authObject.unauthorizedError ? authObject.unauthorizedError : true,
  };
};

const mapDispatchToProps = dispatch => {

    const  inspection_department = window.location.href.includes("inspection-department") ? true: false;
    const admin_console = window.location.href.includes("admin-console") ? true: false;
    
    let category = localStorage.getItem("user_category");

    if(!admin_console && !inspection_department){
	return {
	    onAppStart: () => {
		dispatch(onAppStart());
	    },
	    
	    getBasicInfo: () => {
		dispatch(getBasicInfo());
	    }
	};
    }
    else if(category === "Inspection-Department" || inspection_department){
	return {
	    onAppStart: () => {
		dispatch(onInspectorAppStart());
	    },

	    getBasicInfo: () => {
		dispatch(getBasicInfo());
	    }
	};
    }
    else if(category === "Admin-Console" || admin_console){
	return {
	    onAppStart: () => {
		dispatch(onAdminAppStart());
	    },

	    getBasicInfo: () => {
		dispatch(getBasicInfo());
	    }
	};
    }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes);
